import { BaseModel } from './_Index';

// Motivazione del rinnovo password (issue #3301, FR-034): il backend trasmette un CODICE stabile,
// non una frase. Il testo mostrato all'utente è responsabilità del client, così ritoccarlo non
// richiede un rilascio dell'AuthApi.
export type PasswordChangeReason = 'FIRST_LOGIN' | 'EXPIRED';

export const PASSWORD_CHANGE_REASON_TEXT: Record<PasswordChangeReason, string> = {
    FIRST_LOGIN: 'primo accesso',
    EXPIRED: 'password scaduta',
};

// Degrado per un codice non riconosciuto (client più vecchio dell'AuthApi): mai il codice grezzo,
// mai stringa vuota.
export const PASSWORD_CHANGE_REASON_FALLBACK = 'rinnovo richiesto';

export class Operatore extends BaseModel{
    organizzazioneId?: number;
    title: string;
    firstName: string;
    lastName: string;
    userName: string;
    email: string;
    acceptTerms: boolean;
    jwtToken?: string;
    created: Date;
    update: Date;
    isVerified?: boolean;
    // isActive (blocco account, issue #3169) è ereditato da BaseModel.
    imageUrl?: string;
    roles: string[];

    organizzazioneCodice: string;
    gruppoCodice: string;
    refreshToken?: string;
    // Logout automatico per inattività (issue #3203): minuti distribuiti dall'AuthApi.
    // undefined / ≤ 0 = feature disattivata (nessun timer client).
    inactivityTimeoutMinutes?: number;

    // ── Scadenza password (issue #3301) ───────────────────────────────────────────────────────
    // Parametri di policy, in sola lettura: l'unica via di scrittura è
    // setOperatorePasswordPolicyAsync (FR-021/FR-022).
    passwordExpiryDays?: number | null;
    mustChangePassword?: boolean;
    passwordChangedAt?: string | null;

    // Campi presenti SOLO sulla risposta di login che richiede il rinnovo: in quel caso jwtToken e
    // refreshToken restano vuoti e nessuna sessione viene creata (FR-016/FR-035).
    passwordChangeRequired?: boolean;
    passwordChangeToken?: string | null;
    passwordChangeReason?: PasswordChangeReason | null;
}
